import { requests } from "../API/Api";

export const downloadBlob = (blob: Blob, fileName: string): void => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

export const downloadPublicDocument = (url: string, newTab: boolean = false): void => {
    const link = document.createElement("a");
    link.href = url;
    link.target = newTab ? "_blank" : "_self";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    link.remove();
};

export const downloadAuthenticatedDocument = async (
    url: string,
    fallbackFileName: string
): Promise<void> => {
    const response = await requests.getBlob(url);
    const contentType =
        typeof response.headers["content-type"] === "string"
            ? response.headers["content-type"]
            : "application/octet-stream";
    if (contentType.includes("application/json")) {
        const text = await response.data.text();
        try {
            const body = JSON.parse(text) as { error?: string; flagStatus?: boolean };
            if (body.flagStatus === false || body.error) {
                throw new Error(body.error || "Failed to download document");
            }
        } catch (error) {
            if (error instanceof SyntaxError) {
                // JSON file download, not an error payload
            } else {
                throw error;
            }
        }
        const blob = new Blob([text], { type: contentType });
        downloadBlob(blob, extractFileName(response.headers, fallbackFileName));
        return;
    }
    const blob = new Blob([response.data], { type: contentType });
    downloadBlob(blob, extractFileName(response.headers, fallbackFileName));
};


export const extractFileName = (
    headers: Record<string, unknown>,
    fallbackFileName: string
): string => {
    const contentDisposition =
        (typeof headers["content-disposition"] === "string" ? headers["content-disposition"] : null) ||
        (typeof headers["Content-Disposition"] === "string" ? headers["Content-Disposition"] : null);

    if (!contentDisposition) {
        return fallbackFileName;
    }

    const filenameMatch = new RegExp(/filename[*]?=['"]?([^'";]+)['"]?/i).exec(contentDisposition);

    if (filenameMatch?.[1]) {
        try {
            return decodeURIComponent(filenameMatch[1]);
        } catch {
            return filenameMatch[1];
        }
    }

    return fallbackFileName;
};
